module.exports = __webpack_public_path__ + "img/cloudPurchase_industrySolution4.5810856a.png";